export default {
	griddoTemplatesFolder: "./templates",
	components: {
		ui: "./src/ui/components",
		schemas: "./src/schemas/components"
		// alias: "@components"
	},
	modules: {
		ui: "./src/ui/modules",
		schemas: "./src/schemas/modules"
		// alias: "@modules"
	},
	templates: {
		ui: "./src/ui/templates",
		schemas: "./src/schemas/templates"
		// alias: "@templates"
	},
	objects: {
		schemas: "./src/schemas/objects"
	},
	elements: {
		ui: "./src/ui/elements"
		// alias: "@elements"
	}
};
